import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { UserButton } from "@clerk/clerk-react";
import { buildCloudflareImageUrl } from "@pull/shared";
import { useVendor } from "../hooks/useVendor";

const accountHash = process.env.BUN_PUBLIC_CLOUDFLARE_IMAGES_ACCOUNT_HASH ?? "";

function vendorInitial(name: string): string {
  const trimmed = name.trim();
  return trimmed.length > 0 ? trimmed[0]!.toUpperCase() : "?";
}

function VendorIdentity() {
  const { data: vendor, isLoading } = useVendor();

  if (isLoading || !vendor) {
    return (
      <div className="flex items-center gap-3 px-3 py-3">
        <div className="w-10 h-10 rounded-md bg-gray-100 animate-pulse" />
        <div className="h-4 w-24 rounded bg-gray-100 animate-pulse" />
      </div>
    );
  }

  console.log(vendor);

  const iconUrl =
    vendor.icon_image_id && accountHash
      ? buildCloudflareImageUrl(accountHash, vendor.icon_image_id, "sm")
      : null;

  return (
    <div className="flex items-center gap-3 px-3 py-3">
      {iconUrl ? (
        <img
          src={iconUrl}
          alt={`${vendor.name} icon`}
          className="w-10 h-10 rounded-md object-cover bg-gray-100"
        />
      ) : (
        <div className="w-10 h-10 rounded-md bg-gray-900 flex items-center justify-center text-white text-sm font-semibold">
          {vendorInitial(vendor.name)}
        </div>
      )}
      <div className="min-w-0">
        <div className="text-sm font-semibold text-gray-900 truncate">
          {vendor.name}
        </div>
      </div>
    </div>
  );
}

export function DashboardLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="w-full border-b border-gray-200 bg-white px-8 py-4 flex items-center justify-between">
        <Link to="/" className="text-xl font-semibold text-gray-900">Pull</Link>
        <UserButton />
      </header>

      <div className="flex flex-1">
        <aside className="w-56 border-r border-gray-200 bg-white shrink-0">
          <div className="border-b border-gray-200 px-1 py-2">
            <VendorIdentity />
          </div>
          <nav className="p-4 flex flex-col gap-1">
            <Link
              to="/products/new"
              className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
            >
              + New Product
            </Link>
            <Link
              to="/integrations"
              className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
            >
              Integrations
            </Link>
          </nav>
        </aside>

        <main className="flex-1 px-8 py-10">
          {children}
        </main>
      </div>
    </div>
  );
}
